<script>
import {
    BAlert,
    BCard,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BOverlay,
} from 'bootstrap-vue'
import { LegislationApi } from '@core/api'

function normalizeQuestionIds(questionIds) {
    return questionIds instanceof Array ? [...questionIds] : []
}

export default {
    components: {
        BAlert,
        BCard,
        BCardText,
        BCardTitle,
        BFormCheckbox,
        BOverlay,
    },
    props: {
        value: {
            type: Array,
            default() {
                return []
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        context: {
            type: String,
            default: 'assignment',
        },
    },
    data() {
        return {
            catalog: [],
            selectedQuestionIds: normalizeQuestionIds(this.value),
            showLoading: true,
        }
    },
    watch: {
        value() {
            this.selectedQuestionIds = normalizeQuestionIds(this.value)
        },
    },
    created() {
        LegislationApi
            .getQuestionCatalog(this.context)
            .then(r => {
                this.catalog = r.data
            })
            .finally(() => {
                this.showLoading = false
            })
    },
    methods: {
        isSelected(questionId) {
            return this.selectedQuestionIds.includes(questionId)
        },
        toggle(questionId, selected) {
            if (selected && !this.isSelected(questionId)) {
                this.selectedQuestionIds.push(questionId)
            }

            if (!selected) {
                this.selectedQuestionIds = this.selectedQuestionIds.filter(id => id !== questionId)
            }

            this.emit()
        },
        emit() {
            this.$emit('input', this.selectedQuestionIds)
            this.$emit('change', this.selectedQuestionIds)
        },
    },
}
</script>

<template>
    <b-overlay
        variant="white"
        :show="showLoading"
        spinner-variant="primary"
        blur="0"
        opacity=".85"
        rounded="sm"
    >
        <b-card no-body>
            <div class="card-header pb-1">
                <b-card-title>
                    Questions
                </b-card-title>
            </div>
            <div class="pl-2 pr-2 pb-1">
                <b-alert
                    v-if="!catalog.length"
                    variant="secondary"
                    show
                >
                    <div class="alert-body">
                        No questions available
                    </div>
                </b-alert>

                <b-card
                    v-for="group in catalog"
                    :key="group.id"
                    no-body
                    border-variant="light"
                    class="mb-1"
                >
                    <div class="card-header pb-1">
                        <div>
                            <b-card-title>
                                {{ group.title }}
                            </b-card-title>
                            <b-card-text
                                v-if="group.description"
                                class="mb-0 text-muted"
                            >
                                {{ group.description }}
                            </b-card-text>
                        </div>
                    </div>

                    <div class="pl-2 pr-2 pb-1">
                        <b-alert
                            v-if="!group.questions || !group.questions.length"
                            variant="secondary"
                            show
                        >
                            <div class="alert-body">
                                No questions available
                            </div>
                        </b-alert>

                        <div
                            v-for="question in group.questions"
                            :key="question.id"
                            class="mb-1"
                        >
                            <b-form-checkbox
                                :checked="isSelected(question.id)"
                                :disabled="disabled"
                                @change="selected => toggle(question.id, selected)"
                            >
                                {{ question.question }}
                            </b-form-checkbox>
                            <div
                                v-if="question.description"
                                class="text-muted pl-2"
                            >
                                {{ question.description }}
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>
